import styled from 'styled-components'

export default styled.div`
  display: flex;
  display: -ms-flexbox;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  @media screen and (max-width: 800px) and (-ms-high-contrast: active), screen and (max-width: 800px) and (-ms-high-contrast: none) {
    width: 90% !important;
    display: block !important;
  }
`
